/**
 * The countries one search covers, out of those suggestions may come from (the
 * backend's /public-config): every one of them while the form has no country,
 * only the form's country when it is one of them, and none when it is not — a
 * suggestion from elsewhere would replace the country the user picked.
 */
export function searchCountries(configured: readonly string[], formCountry: string | null | undefined): string[] {
  const code = (formCountry ?? '').trim().toUpperCase();
  if (!code) {
    return [...configured];
  }
  return configured.includes(code) ? [code] : [];
}
